// src/components/vision/VisionStorySection.tsx
import React from 'react';
import {StoryBlock} from './StoryBlock';
import { ConsciousNetworkVisual } from '../../visuals/ConsciousNetworkVisual';

interface StoryData {
  headline: string;
  title1: string;
  p1: string;
  title2: string;
  p2: string;
  title3: string;
  p3: string;
}

interface VisionStorySectionProps {
  storyData: StoryData;
}

export const VisionStorySection: React.FC<VisionStorySectionProps> = ({ storyData }) => {
  // Define the content for each "chapter" of the story
  const storyChapters = [
    {
      iconName: 'heart',
      title: storyData.title1,
      text: 'vision:story.p1',
      // We use a placeholder div for the first visual. Replace with a real <img /> component.
      visual: (
        <div className="w-full h-full bg-slate-200 rounded-xl border-2 border-black flex items-center justify-center p-4">
          <span className="text-slate-500 font-medium text-center">Visual representing humanitarian roots & 'Dopomoga'</span>
        </div>
      ),
      isReversed: false,
    },
    {
      iconName: 'brain',
      // --- THIS IS THE FIX ---
      // BEFORE: title: storyDatalogger.title2,
      // AFTER:
      title: storyData.title2,
      // ----------------------
      text: 'vision:story.p2',
      // Placeholder for the second visual
      visual: (
        <div className="w-full h-full bg-slate-200 rounded-xl border-2 border-black flex items-center justify-center p-4">
          <span className="text-slate-500 font-medium text-center">Visual representing the evolution to 'Dopomogai' & global AI</span>
        </div>
      ),
      isReversed: true,
    },
    {
      iconName: 'globe',
      title: storyData.title3,
      text: 'vision:story.p3',
      // Reuse the excellent ConsciousNetworkVisual for the final conviction
      visual: <ConsciousNetworkVisual />,
      isReversed: false,
    },
  ];

  return (
    <section className="bg-slate-100 py-20 md:py-24 relative story-section-anchor">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 text-center mb-16 md:mb-24">
          {storyData.headline}
        </h2>
        
        <div className="relative space-y-20 md:space-y-24">
          {/* Vertical Timeline Line - only visible on large screens */}
          <div className="absolute left-1/2 top-0 h-full w-0.5 bg-slate-300 -translate-x-1/2 hidden lg:block" aria-hidden="true"></div>
          
          {storyChapters.map((chapter, index) => (
            <div key={index} className="relative">
              {/* Timeline Node - a decorative circle on the timeline */}
              <div className="absolute left-1/2 top-1/2 -translate-y-1/2 -translate-x-1/2 w-4 h-4 bg-slate-900 rounded-full border-4 border-slate-100 hidden lg:block" aria-hidden="true"></div>
              <StoryBlock {...chapter} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
